var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProvisioningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7405_9018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.818007 11.971L1.90001 13.054C2.17859 13.3326 2.50933 13.5537 2.87334 13.7045C3.23735 13.8553 3.6275 13.9329 4.02151 13.9329C4.41552 13.9329 4.80566 13.8553 5.16967 13.7045C5.53368 13.5537 5.86442 13.3326 6.14301 13.054L7.73401 11.463C7.8734 11.3237 7.98397 11.1583 8.05941 10.9763C8.13486 10.7942 8.17369 10.5991 8.17369 10.402C8.17369 10.205 8.13486 10.0098 8.05941 9.82777C7.98397 9.64572 7.8734 9.48031 7.73401 9.34101L4.64001 6.24701C4.48854 6.09423 4.30599 5.97581 4.10472 5.89979C3.90346 5.82378 3.6882 5.79194 3.47355 5.80646C3.2589 5.82097 3.04988 5.88149 2.86068 5.9839C2.67148 6.08631 2.50653 6.22823 2.37701 6.40001C-0.863993 10.8 1.10001 15.434 5.08301 19.418C9.06601 23.402 13.703 25.364 18.105 22.123C18.2765 21.9931 18.418 21.8279 18.5199 21.6385C18.6219 21.4491 18.6819 21.24 18.6959 21.0253C18.71 20.8107 18.6777 20.5955 18.6013 20.3945C18.5248 20.1934 18.4061 20.0111 18.253 19.86L15.159 16.766C14.8777 16.4848 14.4963 16.3268 14.0985 16.3268C13.7008 16.3268 13.3193 16.4848 13.038 16.766L11.446 18.357C11.1674 18.6356 10.9464 18.9663 10.7956 19.3303C10.6448 19.6944 10.5671 20.0845 10.5671 20.4785C10.5671 20.8725 10.6448 21.2627 10.7956 21.6267C10.9464 21.9907 11.1674 22.3214 11.446 22.6L12.546 23.694",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 6.5C12.75 7.18944 12.8858 7.87213 13.1496 8.50909C13.4135 9.14605 13.8002 9.7248 14.2877 10.2123C14.7752 10.6998 15.354 11.0865 15.9909 11.3504C16.6279 11.6142 17.3106 11.75 18 11.75C18.6894 11.75 19.3721 11.6142 20.0091 11.3504C20.646 11.0865 21.2248 10.6998 21.7123 10.2123C22.1998 9.7248 22.5865 9.14605 22.8504 8.50909C23.1142 7.87213 23.25 7.18944 23.25 6.5C23.25 5.81056 23.1142 5.12787 22.8504 4.49091C22.5865 3.85395 22.1998 3.2752 21.7123 2.78769C21.2248 2.30018 20.646 1.91347 20.0091 1.64963C19.3721 1.3858 18.6894 1.25 18 1.25C17.3106 1.25 16.6279 1.3858 15.9909 1.64963C15.354 1.91347 14.7752 2.30018 14.2877 2.78769C13.8002 3.2752 13.4135 3.85395 13.1496 4.49091C12.8858 5.12787 12.75 5.81056 12.75 6.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 4.25V8.75",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 6.5H20.25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7405_9018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvisioningIcon);
export default __webpack_public_path__ + "static/media/provisioning-icon.17bf78621b34710d55efa9dada0ee77d.svg";
export { ForwardRef as ReactComponent };